import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.0001 5.25C12.4143 5.25 12.7501 5.58579 12.7501 6V7.5C12.7501 7.91421 12.4143 8.25 12.0001 8.25C11.5858 8.25 11.2501 7.91421 11.2501 7.5V6C11.2501 5.58579 11.5858 5.25 12.0001 5.25Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M17.8337 6.16637C14.6119 2.94454 9.38832 2.94454 6.16649 6.16637C2.94467 9.38818 2.94466 14.6118 6.16649 17.8336C9.3883 21.0554 14.6119 21.0554 17.8337 17.8336C21.0554 14.6119 21.0552 9.38823 17.8337 6.16637ZM18.8944 5.10571C22.702 8.91332 22.702 15.0867 18.8944 18.8943C15.0868 22.7019 8.91343 22.7019 5.10583 18.8943C1.29822 15.0867 1.29822 8.9133 5.10583 5.10571C8.91344 1.2981 15.0868 1.2981 18.8944 5.10571Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.0001 15.75C12.4143 15.75 12.7501 16.0858 12.7501 16.5V18C12.7501 18.4142 12.4143 18.75 12.0001 18.75C11.5858 18.75 11.2501 18.4142 11.2501 18V16.5C11.2501 16.0858 11.5858 15.75 12.0001 15.75Z"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.1071 8.25C10.3573 8.25 9.75006 8.85721 9.75006 9.607C9.75006 10.229 10.173 10.7711 10.7765 10.9225L13.5885 11.6275C14.859 11.9462 15.7501 13.088 15.7501 14.398C15.7501 15.9764 14.47 17.255 12.8931 17.255H11.2501C9.59285 17.255 8.25006 15.9122 8.25006 14.255C8.25006 13.8408 8.58585 13.505 9.00006 13.505C9.41428 13.505 9.75006 13.8408 9.75006 14.255C9.75006 15.0838 10.4213 15.755 11.2501 15.755H12.8931C13.6421 15.755 14.2501 15.1476 14.2501 14.398C14.2501 13.776 13.8271 13.2339 13.2237 13.0825L10.4117 12.3775C9.14112 12.0588 8.25006 10.917 8.25006 9.607C8.25006 8.02879 9.52885 6.75 11.1071 6.75H12.7501C14.4073 6.75 15.7501 8.09279 15.7501 9.75H14.2501C14.2501 8.92121 13.5788 8.25 12.7501 8.25H11.1071Z"
    }, null, -1)
  ])))
}
export default { render: render }